/**
 * * This file was automatically generated by react-scripts-trackman codegen.
 * * YOU ARE FREE TO MODIFY IT AS NEEDED.
 * * The only thing you should not modify is this very comment.
 * * The list below is used to generate new hooks based on their name.
 * * When new hook name is not found in the list, it will be generated
 * * and appended at the end of the file.
 * *
 * * Previously generated hooks (DO NOT MODIFY): [useGetLookupSeasons, usePostLookupLevels, usePostLookupBatterTeams, usePostLookupPitcherTeams, usePostLookupUmpireLeagues, usePostLookupUmpireSessions, usePostLookupUmpires, usePostLookupBatters, usePostLookupPitchers, usePostLookupBatterSessions, usePostLookupPitcherSessions, useGetLookupGameTypes, useGetLookupPracticeSessionTypes]
 */

import { GameTypeEnum, LookupDateRangeQueryItemDto, LookupSessionsQueryDto, PlayerType } from '../types/CodegenLookupTypes';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useStores } from 'index';

export const useGetLookupSeasons = () => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['getLookupSeasons'],
    queryFn: () => codegenLookupService.getLookupSeasons(),
    gcTime: Infinity,
  });
};

export const usePostLookupLevels = (dateRanges: LookupDateRangeQueryItemDto[] | undefined, gameType: string | undefined) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['usePostLookupLevels', dateRanges, gameType],
    queryFn: () =>
      dateRanges && gameType ? codegenLookupService.postLookupLevels({ dateRanges, gameType: gameType as GameTypeEnum }) : undefined,
    gcTime: Infinity,
    enabled: !!dateRanges && !!gameType,
  });
};

export const usePostLookupBatterTeams = (
  dateRanges: LookupDateRangeQueryItemDto[] | undefined,
  levelId: string | undefined,
  gameType: string | undefined
) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['usePostLookupBatterTeams', dateRanges, levelId],
    queryFn: () =>
      dateRanges && levelId && gameType
        ? codegenLookupService.postLookupBatterTeams({ dateRanges, levelId, gameType: gameType as GameTypeEnum })
        : undefined,
    gcTime: Infinity,
    enabled: !!dateRanges && !!levelId && !!gameType,
  });
};

export const usePostLookupPitcherTeams = (
  dateRanges: LookupDateRangeQueryItemDto[] | undefined,
  levelId: string | undefined,
  gameType: string | undefined
) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['usePostLookupPitcherTeams', dateRanges, levelId],
    queryFn: () =>
      dateRanges && levelId && gameType
        ? codegenLookupService.postLookupPitcherTeams({ dateRanges, levelId, gameType: gameType as GameTypeEnum })
        : undefined,
    gcTime: Infinity,
    enabled: !!dateRanges && !!levelId && !!gameType,
  });
};

export const usePostLookupUmpireLeagues = (dateRanges: LookupDateRangeQueryItemDto[] | undefined) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['usePostLookupUmpireLeagues', dateRanges],
    queryFn: () => (dateRanges ? codegenLookupService.postLookupUmpireLeagues({ dateRanges }) : undefined),
    gcTime: Infinity,
    enabled: !!dateRanges,
  });
};

export const usePostLookupUmpireSessions = (
  dateRanges: LookupDateRangeQueryItemDto[] | undefined,
  leagueIds: string[] | undefined,
  umpireIds: string[] | undefined
) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['usePostLookupUmpireSessions', dateRanges, leagueIds, umpireIds],
    queryFn: () =>
      dateRanges && leagueIds && umpireIds
        ? codegenLookupService.postLookupUmpireSessions({ dateRanges, leagueIds, umpireIds })
        : undefined,
    gcTime: Infinity,
    enabled: !!dateRanges && !!leagueIds && !!umpireIds,
  });
};

export const usePostLookupUmpires = (dateRanges: LookupDateRangeQueryItemDto[] | undefined, leagueIds: string[] | undefined) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['usePostLookupUmpires', dateRanges, leagueIds],
    queryFn: () => (dateRanges && leagueIds ? codegenLookupService.postLookupUmpires({ dateRanges, leagueIds }) : undefined),
    gcTime: Infinity,
    enabled: !!dateRanges && !!leagueIds,
  });
};

export const usePostLookupBatters = (
  dateRanges: LookupDateRangeQueryItemDto[] | undefined,
  levelId: string | undefined,
  teamId: string | undefined
) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['usePostLookupBatters', dateRanges, levelId, teamId],
    queryFn: () => (dateRanges && levelId && teamId ? codegenLookupService.postLookupBatters({ dateRanges, levelId, teamId }) : undefined),
    gcTime: Infinity,
    enabled: !!dateRanges && !!levelId && !!teamId,
  });
};

export const usePostLookupPitchers = (
  dateRanges: LookupDateRangeQueryItemDto[] | undefined,
  levelId: string | undefined,
  teamId: string | undefined
) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['usePostLookupPitchers', dateRanges, levelId, teamId],
    queryFn: () => (dateRanges && levelId && teamId ? codegenLookupService.postLookupPitchers({ dateRanges, levelId, teamId }) : undefined),
    gcTime: Infinity,
    enabled: !!dateRanges && !!levelId && !!teamId,
  });
};

export const usePostLookupBatterSessions = (
  dateRanges: LookupDateRangeQueryItemDto[] | undefined,
  levelId: string | undefined,
  teamId: string | undefined,
  playerIds: string[] | undefined,
  gameType: string | undefined
) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['usePostLookupBatterSessions', dateRanges, levelId, teamId, playerIds, gameType],
    queryFn: () =>
      dateRanges && levelId && teamId && playerIds && gameType
        ? codegenLookupService.postLookupBatterSessions({
            dateRanges,
            levelId,
            teamIds: [teamId],
            playerIds,
            gameType: gameType as GameTypeEnum,
          })
        : undefined,
    gcTime: Infinity,
    enabled: !!dateRanges && !!levelId && !!teamId && !!playerIds && !!gameType,
  });
};

export const usePostLookupPitcherSessions = (
  dateRanges: LookupDateRangeQueryItemDto[] | undefined,
  levelId: string | undefined,
  teamId: string | undefined,
  playerIds: string[] | undefined,
  gameType: string | undefined
) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['usePostLookupPitcherSessions', dateRanges, levelId, teamId, playerIds, gameType],
    queryFn: () =>
      dateRanges && levelId && teamId && playerIds && gameType
        ? codegenLookupService.postLookupPitcherSessions({
            dateRanges,
            levelId,
            teamIds: [teamId],
            playerIds,
            gameType: gameType as GameTypeEnum,
          })
        : undefined,
    gcTime: Infinity,
    enabled: !!dateRanges && !!levelId && !!teamId && !!playerIds && !!gameType,
  });
};

export const useGetLookupGameTypes = () => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['getLookupGameTypes'],
    queryFn: () => codegenLookupService.getLookupGameTypes(),
  });
};

export const useGetLookupPracticeSessionTypes = (playerType: string) => {
  const codegenLookupService = useStores().codegenLookupService;

  return useQuery({
    queryKey: ['getLookupPracticeSessionTypes', playerType],
    queryFn: () => codegenLookupService.getLookupPracticeSessionTypes(playerType as PlayerType),
  });
};
